{
  "version": 1,
  "asset_id": "618140de-c1a3-4ba3-9ffb-791afb301591",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/618140de-c1a3-4ba3-9ffb-791afb301591/sleeve-hiatal-type-1-es-1141.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/618140de-c1a3-4ba3-9ffb-791afb301591/sleeve-hiatal-type-1-es-1141.webp",
  "original_filename": "sleeve-hiatal-type-1-es-1141.webp",
  "size": 78812,
  "content_type": "image/webp",
  "created_at": "2026-09-26T21:38:52Z"
}
